/* eslint-disable no-template-curly-in-string */
/* eslint-disable quotes */
export const enTranslations = {};
